import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { useTranslation } from "react-i18next";
import { IFormValidator } from "../../../core/FormValidator";
import { ResourceTextApplication } from "../../../core/resources";
import { IFarmQuestion } from "../../../interfaces/IProductionPlan";
import Question from "./Question/Question";
import { QuestionResourceText } from "../../../interfaces/enums";

interface IProps {
    data: IFarmQuestion[];
    setData: (data: IFarmQuestion[]) => void;
    readonly?: boolean;
    validator: IFormValidator;
}

export default function Environment({ data, setData, readonly, validator }: IProps){
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaLayout', 'AnelmaCattleProductionPlan']);

    const getQuestion = (question: IFarmQuestion, error?: boolean, required?: boolean) => {
        return (
            <Question
                question={question}
                setQuestion={(question) => {
                    let updated = data.map((q) => {
                        if (q.ResourceId == question.ResourceId && q.Type == question.Type)
                            return question;
                        return q;
                    });
                    setData(updated);
                }}
                validator={validator}
                readonly={readonly}
                error={error}
                required={required}
            />
        );
    }

    const getQuestionElement = (questionResource: QuestionResourceText) => {
        let i = data.findIndex(q => q.ResourceId === questionResource.toString());

        if (i != -1) {
            return getQuestion(data[i]);
        }

        return <></>;
    }

    return (
        <Grid container direction='row' style={{ paddingLeft: 40, paddingTop: '20px' }}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Typography variant="h4">{t('AnelmaLayout:1072')}</Typography>

                {getQuestionElement(QuestionResourceText.YearlyLawnCropAmount)}

                {getQuestionElement(QuestionResourceText.CommittedToEnviromentalSupportConditions)}

                {getQuestionElement(QuestionResourceText.IsBiogasProducer)}

                {getQuestionElement(QuestionResourceText.IsSolarPowerProducer)}

                {getQuestionElement(QuestionResourceText.IsWindPowerProducer)}

                {getQuestionElement(QuestionResourceText.AdditionalInfo)}
            </Grid>
        </Grid>
    );
}